<template>
  <AppScreenshotsSelector
    v-loading="loading"
    key-prop="token"
    class="upload-draft-app-screenshots"
    :images="screenshotsModel"
    can-change-order
    @file-select="handleAddNewScreenshots"
    @delete="deleteScreenshot"
    @change="handleOrderChange"
  />
</template>

<script>
import { mapActions } from 'vuex';
import { UPDATE_DRAFT_APP } from '@/store/types';
import AppScreenshotsSelector from '../../common/AppScreenshotsSelector';
import { DraftApps } from '@/api/api';

export default {
  name: 'UploadDraftAppScreenshots',
  components: { AppScreenshotsSelector },
  props: {
    screenshots: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loading: false,
      screenshotsModel: [],
    };
  },
  watch: {
    screenshots: {
      immediate: true,
      handler() {
        this.screenshotsModel = [...this.screenshots];
      },
    },
  },
  methods: {
    ...mapActions({ upadteDraftApp: UPDATE_DRAFT_APP }),

    handleAddNewScreenshots(images) {
      if (!images?.length) return;
      this.loading = true;

      const uploadPromises = images.map(image => this.uploadScreenshot(image));

      return Promise.allSettled(uploadPromises).then(() => {
        this.loading = false;
      });
    },

    uploadScreenshot(screenshot) {
      const id = this.$route.params.appId;

      return DraftApps.uploadScreenshot({ id, screenshot })
        .then(({ message, token, url }) => {
          if (message) this.$message.success(message);
          this.screenshotsModel.push({ token, url });
          this.$emit('update:screenshots', this.screenshotsModel);
        })
        .catch(({ message }) => this.$message.error(message));
    },

    deleteScreenshot(token) {
      const id = this.$route.params.appId;

      return DraftApps.deleteScreenshot({ id, token })
        .then(({ message }) => {
          if (message) this.$message.success(message);

          this.screenshotsModel = this.screenshotsModel.filter(
            img => img.token !== token,
          );
          this.$emit('update:screenshots', this.screenshotsModel);
        })
        .catch(({ message }) => this.$message.error(message));
    },

    handleOrderChange(screenshots) {
      this.screenshotsModel = [...screenshots];
      this.$emit('update:screenshots', this.screenshotsModel);
    },
  },
};
</script>
